import { IOffer, TOfferCategory } from '../../../types/offer';

const COMMERCIAL_LAND_CATEGORIES: TOfferCategory[] = ['commercialLandRent', 'commercialLandSale'];

export function isCommercialLand(offer: IOffer): boolean {
  return !!offer.category && COMMERCIAL_LAND_CATEGORIES.includes(offer.category);
}
